import { createContext, Dispatch, SetStateAction } from 'react'

import { ShopifyVariantDetails } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ISwatch } from '@src/quince-site-common/src/domains/Swatch'
import {
  GiftProductCardStates,
  GiftProductEligibilityDetails,
  ShopifyIdProductMap,
} from '@src/quince-site-common/src/hooks/cart/context/giftProduct.types'

import IShopifyCheckout from '../../../domains/shopify/ShopifyCheckout'
import { LineItemDetails } from '../../../organisms/appLayout/molecules/cartPopUp/cart.helper'

import useCartContextHelper from './use-cart-context-helper'

interface BaseCartContextState {
  isInitialized: boolean
  isInitializing: boolean
  setIsCartPopUpOpen: Dispatch<SetStateAction<boolean>>
}

type UseCartContextHelperReturnType = ReturnType<typeof useCartContextHelper>

export type CartContextState =
  | (BaseCartContextState &
      Pick<
        UseCartContextHelperReturnType,
        | 'removeLineItem'
        | 'updateLineItem'
        | 'addToCart'
        | 'addMultipleToCart'
        | 'refreshShopifyCheckout'
        | 'buyNowCart'
        | 'isBuyNowInProgress'
        | 'updateGiftingFlag'
        | 'updateGiftingDetails'
        | 'moveToSaveForLater'
        | 'moveBackToCart'
        | 'removeAllOutOfStockItems'
      > & {
        isInitialized: true
        isActionInProgress: boolean
        errorMessage: string
        setErrorMessage: Dispatch<SetStateAction<string>>
        shopifyCheckout?: IShopifyCheckout
        lineItemDetailsByVariantId: Record<string, LineItemDetails>
        isCartPopUpOpen: boolean
        isGoldBarInCart: boolean
        setIsGoldBarInCart: React.Dispatch<React.SetStateAction<boolean>>
        isLoggedInUserEligbleForGoldBar: boolean
        cartTotalItemsCount: number
        giftProductEligibilityDetails: GiftProductEligibilityDetails[]
        giftCardShopifyIdToSeenState: GiftProductCardStates
        giftCardShopifyIdToDeleteState: GiftProductCardStates
        giftCardShopifyIdToIsPresentInCard: GiftProductCardStates
        updateGiftCardShopifyIdToDelete: (giftShopifyId: number) => void
        giftCardShopifyIdToProductMap: ShopifyIdProductMap
        onSwatchLinkClick: (swatchData: ISwatch[]) => Promise<void>
        swatchData: object | null
        addSwatchesToCart: (id: number[]) => Promise<void>
        removeSwatches: (ids: number[]) => Promise<void>
        setSwatchData: (data: any) => void
        swatchVariantDetailMap: Record<string, ShopifyVariantDetails>
      })
  | (BaseCartContextState & {
      isInitialized: false
    })

const CartContext = createContext<CartContextState>({
  isInitialized: false,
  isInitializing: false,
  setIsCartPopUpOpen: () => undefined,
})

CartContext.displayName = 'CartContext'

export default CartContext
